import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const changePendingLockStatus = {
  name: "changePendingLockStatus" as const,
  input: z.object({
    returnId: zExt.objectId(),
    metadataKey: z.string(),
    action: createEnum(["retry", "complete"]),
  }),
  output: z.null(),
};
